// isiPod
export default (function() {
  return navigator.userAgent.toLowerCase().indexOf('ipod') !== -1;
})();
